<div class="d-flex flex-column h-100">
  <div mat-dialog-title>
    <button *ngIf="isHandset" mat-flat-button class="button--square mat-secondary mr-2" (click)="onCancel()">
      <mat-icon svgIcon="arrow-left"></mat-icon>
    </button>
    <div data-testId="user-preferences-title" class="h4 mb-0" i18n="@@shared.userPreferences.titleUserPreferences">
      User Preferences
    </div>
    <button *ngIf="!isHandset" mat-icon-button (click)="onCancel()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <form [formGroup]="userPreferencesForm">
      <mat-card class="card">
        <mat-card-content class="card-content">
          <div
            data-testId="add-entry-behavior-title"
            class="h5"
            i18n="@@shared.userPreferences.lblActivitiesAddEntryBehavior"
          >
            Activities: "Add entry" Button Behavior
          </div>
          <hr />
          <p
            data-testId="auto-populate-finish-time-title"
            i18n="@@shared.userPreferences.txtAutoPopulateActivityFinishTime"
            class="mb-3 font-weight-medium"
          >
            Auto-Populate Finish Time
          </p>
          <mat-checkbox
            data-testId="set-auto-populate-finish-time-state"
            formControlName="enableFinishTimeAutoPopulationForActivities"
            i18n="@@shared.userPreferences.lblEnableAutoPopulateActivityFinishTime"
          >
            Auto-populate time from local device: finish time in last existing activity + start time in new activity
          </mat-checkbox>
          <hr />
          <p
            data-testId="adding-activities-title"
            i18n="@@shared.userPreferences.txtAddingActivities"
            class="mb-3 font-weight-medium"
          >
            Adding Activities
          </p>
          <div [formGroup]="userPreferencesForm">
            <mat-radio-group formControlName="activitySelectionVersion" class="d-flex flex-column">
              <div class="d-flex flex-column mb-3">
                <mat-radio-button
                  data-testId="set-next-activity-state"
                  [value]="ActivitySelectionVersion.SelectNext"
                  i18n="@@shared.userPreferences.lblSelectNext"
                >
                  Next activity
                </mat-radio-button>
              </div>
              <div class="d-flex flex-column mb-3">
                <mat-radio-button
                  data-testId="set-repeat-existing-activity-state"
                  [value]="ActivitySelectionVersion.RepeatLast"
                  i18n="@@shared.userPreferences.lblRepeatLast"
                >
                  Repeat existing activity
                </mat-radio-button>
              </div>
              <div class="d-flex flex-column">
                <mat-radio-button
                  data-testId="set-blank-state"
                  [value]="ActivitySelectionVersion.Blank"
                  i18n="@@shared.userPreferences.lblBlankActivity"
                >
                  Blank
                </mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </mat-card-content>
      </mat-card>
    </form>
  </div>
  <div mat-dialog-actions>
    <button
      *ngIf="isAppOnline"
      data-testId="save-user-preferences"
      mat-flat-button
      color="primary"
      (click)="save()"
      cdkFocusInitial
    >
      <mat-icon svgIcon="check"></mat-icon>
      <span>{{ StaticMessage.DoneButton | staticMessage }}</span>
    </button>
    <button mat-button color="primary" data-testId="cancel-user-preferences-changes" (click)="onCancel()">
      {{ (isAppOnline ? StaticMessage.CancelButton : StaticMessage.CloseButton) | staticMessage }}
    </button>
  </div>
</div>
